const YEARS_BACK = 6;

/**
 * Selectable years for the range picker's year menu: the six previous years up to and
 * including today's. No future years.
 */
export const buildYearOptions = (today: Date): { value: number; label: string }[] => {
  const current = today.getUTCFullYear();
  return Array.from({ length: YEARS_BACK + 1 }, (_, offset) => {
    const y = current - YEARS_BACK + offset;
    return { value: y, label: String(y) };
  });
};
